import { create } from 'zustand';
import { AddCategorySchemaT } from '../types/schema/categorySchema';

// Define the type for TeamRequest

// Define the store
type CategoryRequestStore = {
  currentCategory: AddCategorySchemaT | null; // Changed from array to single object
  setCurrentCategory: (category: AddCategorySchemaT | null) => void;
  clearCurrentCategory: () => void;
};

const useCategoryRequestStore = create<CategoryRequestStore>(set => ({
  currentCategory: null,
  setCurrentCategory: category => set({ currentCategory: category }),
  clearCurrentCategory: () => set({ currentCategory: null }),
}));

export default useCategoryRequestStore;
